import { useMutation, useQueryClient } from '@tanstack/react-query'
import { userSuggestionsApi } from '@/services/api/userSuggestions'
import type { CreateSuggestionInput } from '@brent/shared/types'
import type { UpdateSuggestionInput } from '@/services/api/userSuggestions'

export function useCreateUserSuggestion(username: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateSuggestionInput) => userSuggestionsApi.create(username, data),
    onSuccess: () => {
      // Invalidate suggestions list for this user
      queryClient.invalidateQueries({ queryKey: ['admin', 'users', username, 'suggestions'] })
    },
  })
}

export function useUpdateUserSuggestion(username: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ suggestionId, data }: { suggestionId: string; data: UpdateSuggestionInput }) =>
      userSuggestionsApi.update(username, suggestionId, data),
    onSuccess: () => {
      // Invalidate suggestions list for this user
      queryClient.invalidateQueries({ queryKey: ['admin', 'users', username, 'suggestions'] })
    },
  })
}

export function useDeleteUserSuggestion(username: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (suggestionId: string) => userSuggestionsApi.delete(username, suggestionId),
    onSuccess: () => {
      // Invalidate suggestions list for this user
      queryClient.invalidateQueries({ queryKey: ['admin', 'users', username, 'suggestions'] })
    },
  })
}
